import React from 'react';

function RelativeLoaderTemplate() {
	return (
		<div className="spinnercont">
			<div className="spinner"></div>
		</div>
	);
}

export default RelativeLoaderTemplate;



// WEBPACK FOOTER //
// ./src/themes/default/components/RelativeLoaderTemplate.jsx